module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"sk":{"PageHomepage":{"siteName":"PRAKTICKÝ SPRIEVODCA PRE MAMIČKY A DETI"}},"cs":{}}')
  delete Component.options._Ctor
}
